import http from '../api/httpRequest.js'

export default {
	state: {
		registration: {
			mode: []
		},
		webrtc: {},
		// 一对一通话服务配置，由 /system/config 下发；url 缺失时通话不可用
		livekit: {
			url: '',
			maxChannel: 0
		},
		app: {},
		s3Url: '',
	},
	mutations: {
		setConfig(state, config) {
			state.webrtc = config.webrtc;
			// 注册方式由服务端 /system/config 下发，注册页按 mode 渲染手机号/邮箱字段；
			// 未下发或 mode 为空时回退手机号注册，避免注册页读取 mode[0] 得到 undefined 导致表单不渲染
			const registration = config.registration || {};
			const modes = Array.isArray(registration.mode) ? registration.mode.filter(Boolean) : [];
			state.registration = Object.assign({}, registration, {
				mode: modes.length ? modes : ["phone"]
			});
			state.livekit = config.livekit || { url: '', maxChannel: 0 };
			state.app = config.app;
			state.s3Url = config.s3Url || '';
		}
	},
	actions: {
		loadConfig(context) {
			return new Promise((resolve, reject) => {
				http({
					url: '/system/config',
					method: 'GET'
				}).then((config) => {
					console.log("系统配置", config)
					context.commit("setConfig", config);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}

}